import { ActionTypes } from '../constants'
import Api, { apiAction } from '../api'
import { User } from '../models/users'

function verificationRequest() {
  return { type: ActionTypes.VERIFICATION_REQUEST }
}

function verificationSuccessful(response) {
  return {
    type: ActionTypes.VERIFICATION_SUCCESS,
    user: response.data && new User(response.data)
  }
}

function verificationError(error) {
  return {
    type: ActionTypes.VERIFICATION_FAILURE,
    error: error
  }
}

export const verify = () => {
  return apiAction({
    requestor: () => Api.sessions.find({ id: 'me' }),
    onBeforeSend: verificationRequest,
    onSuccess: (response) => verificationSuccessful(response),
    onFailure: (error) => verificationError(error)
  })
}

function logoutRequest() {
  return { type: ActionTypes.LOGOUT_REQUEST }
}

function logoutSuccessful(response, state) {
  try { window.setGAUserID(); }
  catch(e) { console.error(e); }

  const { data: { sso, platform } } = response;
  if (sso) { window.location.href = platform; }
  else { window.location.href = '/' }

  return {
    type: ActionTypes.LOGOUT_SUCCESS,
    state: { global: state.global }
  }
}

function logoutError(error) {
  return {
    type: ActionTypes.LOGOUT_FAILURE,
    error: error
  }
}

export const logout = () => (dispatch, getState) => {
  return dispatch(
    apiAction({
      requestor: () => Api.sessions.delete({ id: 'me' }),
      onBeforeSend: logoutRequest,
      onSuccess: (response) => logoutSuccessful(response, getState()),
      onFailure: (error) => logoutError(error)
    })
  )
}

function shouldFetchUser(state) {
  const { session: { verificating, user, updatedOn } } = state
  if (verificating) { return false }

  try {
    if (!user && window.jwtProxy && window.jwtProxy.state && window.jwtProxy.state.authenticated) {
      return true
    }
  } catch (e) {}

  if (!user) { return false }

  return !updatedOn || (new Date() - updatedOn) > 30000
}

export function fetchUserIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchUser(getState())) {
      return dispatch(verify())
    }
  }
}
